import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { logout } from "../../actions/authenActions";

const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export const fetchCredentials = createAsyncThunk(
  "s1Credentials/fetchCredentials",
  async ({ license_key }, { dispatch, rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${baseURL}/s1_pathology/api/fetch_credentials/`,
        { license_key },
      );
      return res.data;
    } catch (error) {
      if (error.response && error.response.status === 403) dispatch(logout());
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  },
);

export const saveCredentials = createAsyncThunk(
  "s1Credentials/saveCredentials",
  async (
    { license_key, username, password, organization },
    { dispatch, rejectWithValue },
  ) => {
    try {
      const res = await axios.post(
        `${baseURL}/s1_pathology/api/save_credentials/`,
        { license_key, username, password, organization },
      );
      return res.data;
    } catch (error) {
      if (error.response && error.response.status === 403) dispatch(logout());
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  },
);

const credentialsSlice = createSlice({
  name: "s1Credentials",
  initialState: {
    creds: null,
    status: "idle",
    error: null,
    message: null,
    deploymentType: null,
  },
  reducers: {
    clearMessage(state) {
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCredentials.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCredentials.fulfilled, (state, action) => {
        state.status = "idle";
        state.creds = action.payload?.creds || null;
        state.deploymentType = action.payload?.deployment_type || null;
      })
      .addCase(fetchCredentials.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload || "Failed to fetch credentials";
      })
      .addCase(saveCredentials.pending, (state) => {
        state.status = "saving";
        state.error = null;
      })
      .addCase(saveCredentials.fulfilled, (state, action) => {
        state.status = "idle";
        state.message = action.payload?.message || "Credentials saved";
        if (action.payload?.creds) state.creds = action.payload.creds;
      })
      .addCase(saveCredentials.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload || "Failed to save credentials";
      });
  },
});

export const { clearMessage } = credentialsSlice.actions;
export default credentialsSlice.reducer;
